import React from 'react';
import styled from 'styled-components';

// Components
import { FMLWorkflow } from './FMLWorkflow';
import { Scrollbar } from '@repo/design-system';
import { TLCard } from '@repo/ui';

/**
 * The Edit panel is FML's page (spec retire-edit-mode-teardown, R1): the FML import alone, with no
 * section switcher. Every other job the panel did moved out (opening hours, placing a twin and its
 * opening view to onboarding; organisations to Admin), the Pipeline tab went with the deprecated
 * pipeline, and the Twin tab went last. The only way in is Admin's Open FML link (`fmlPageLink`),
 * through the `?edit=` handshake. A `tab` value in the address, from an older link, is not read.
 *
 * The alerts form (`EditThresholdAlerts.tsx`) is kept, unmounted, because alerts will be wired up a
 * new way later (epic retire-edit-mode decision). It is not dead code to delete.
 */
interface Props {
  className?: string;
}

export const Editor: React.FC<Props> = ({ className }) => (
  <div className={className}>
    <Scrollbar right={0} maxHeight={'calc(100vh - 210px)'} className="right-scrollable-container">
      <div className="panel">
        <TLCard size="small">
          <section aria-label="FML">
            <FMLWorkflow />
          </section>
        </TLCard>
      </div>
    </Scrollbar>
  </div>
);

export default styled(Editor)`
  width: 740px;

  .panel {
    width: 740px;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
